/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Item_Stats_DecreasedInputs */

const he_item_stats_decreased = /** @type {(inputs: Item_Stats_DecreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המחיר ירד`)
};

const en_item_stats_decreased = /** @type {(inputs: Item_Stats_DecreasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price decreased`)
};

/**
* | output |
* | --- |
* | "Price decreased" |
*
* @param {Item_Stats_DecreasedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const item_stats_decreased = /** @type {((inputs?: Item_Stats_DecreasedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Stats_DecreasedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_item_stats_decreased(inputs)
	return en_item_stats_decreased(inputs)
});